<template>
  <div id="app">
    <video-player :options="videoOptions"/>
  </div>
</template>

<script>

import VideoPlayer from "./components/VideoPlayer";

export default {
  name: 'app',
  components: {
    VideoPlayer

  },
  data(){
    return {
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: [
          {
            src: 'https://static1.qmusic.medialaancdn.be/store/creative-development/joe-interactive-video/JoeLive_2020_Aftermovie.mp4',
            type: "video/mp4"
          }
        ],
        aspectRatio: "16:9"
      }
    }
  },
  methods: {

  },
  computed: {

  },
  watch: {
  },
    created(){


    }
}
</script>

<style lang="scss">

  @import "~q-creative/q-styles/q-fonts";
  @import "~video.js/dist/video-js.css";



  @mixin mobile {
    @media (max-width: 749px) {
      @content;
    }
  }

  body{
    margin: 0;
    background: black;
  }

  #app {
    font-family: 'Geomanist', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
    width: 100%;
    margin: auto;
    //margin-top: 2%;
    height: auto;
    font-size: 20px;
    position: relative;


    .vjs-progress-control{
      visibility: hidden;
    }

    .vjs-remaining-time{
      visibility: hidden;
    }

    .vjs-fullscreen-control{
      visibility: hidden;
    }

    .vjs-picture-in-picture-control{
      visibility: hidden;
    }

    .vjs-big-play-button{
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      border-radius: 50%;
      width: 75px;
      height: 75px;
      line-height: 75px;
      background: #CEDC00;
      border: none;

      .vjs-icon-placeholder:before{
        color: #094C59;
        transform: scale(1.5);
      }
      //line-height: 10%;
    }

    .vjs-control-bar{
      background: rgba(9,76,89, 0.7);
    }



  }



</style>

